import React from 'react'
import {
  Modal,
  ModalBody
} from 'reactstrap'
import LoginForm from '../containers/LoginForm'
import PropTypes from 'prop-types'
import html from 'react-inner-html'

const LoginModal = ({ isOpen, message }) => (
  <Modal isOpen={isOpen} backdrop centered>
    <ModalBody className='login__modal__form'>
      <div className={'form-title'} {...html(message)} />
      <LoginForm section={'login'} />
    </ModalBody>
  </Modal>
)

LoginModal.propTypes = {
  isOpen: PropTypes.bool,
  message: PropTypes.string
}

export default LoginModal



// WEBPACK FOOTER //
// ./src/molecules/components/LoginModal.js